import { Form, FormInstance, Row } from "antd";
import { useFetchById } from "../../hooks/useFetchById";
import { Loader } from "../../../../components/Loader";
import { Footer } from "./Footer";
import { FileFormItem } from "./FileFormItem";
import { FormItem } from "./FormItem";
import { useCallback } from "react";
import { AssignDropdown } from "./AssignDropdown";
import { useAssignTask } from "../../hooks/useAssignTask";
import { usePermissions } from "../../../../lib/hooks/usePermissions";
import { Parameters } from "./Parameters";

type SidebarProps = {
  id: string;
  isClosed: boolean;
  setTaskIdToClose: React.Dispatch<React.SetStateAction<string | undefined>>;
  showSideBar: (val: boolean) => void;
  reload: () => void;
};

export const Sidebar = ({ id, isClosed, setTaskIdToClose, showSideBar, reload }: SidebarProps) => {
  const { hasAccessByController } = usePermissions("WorkTasks");

  const [form]: FormInstance[] = Form.useForm();

  const { isLoading, data } = useFetchById(id, form);

  const { isLoading: isSaving, assign } = useAssignTask(id, reload);

  const openCloseModal = useCallback(() => {
    setTaskIdToClose(id);
    showSideBar(false);
  }, [id, setTaskIdToClose, showSideBar]);

  return (
    <>
      <Row className="py-8 px-6 d-block sidebar-body user-content">
        {isLoading ? (
          <Loader fontSize="64px" />
        ) : (
          <Form
            form={form}
            autoComplete="off"
            layout="vertical"
            className="w-100"
            requiredMark={false}
            disabled={isSaving}
          >
            {hasAccessByController("Modify") && (
              <AssignDropdown isSaving={isSaving} isClosed={isClosed} form={form} data={data} />
            )}

            {data.fileName && <FileFormItem id={id} />}

            <FormItem label="Account #" value={data.contractNumber} accId={data.contractId} />

            <FormItem label="Requested By" value={data.createdBy} />
            {data.createdByEmail &&
              (data.createdByEmail ? <span className="ml-3 text-md title">{data.createdByEmail}</span> : null)}

            <FormItem label="Created Date" value={data.sentAt} />

            {data.parameters && <Parameters parameters={data.parameters} />}

            {isClosed && (
              <>
                <FormItem label="Closed" value={data.closed} />

                <FormItem label="Comment Sent" value={data.comment} />
              </>
            )}
          </Form>
        )}
      </Row>
      <Footer
        form={form}
        isClosed={isClosed}
        isSaving={isSaving}
        openCloseModal={openCloseModal}
        showSideBar={showSideBar}
        assign={assign}
      />
    </>
  );
};
